import { Link } from 'gatsby';
import React from 'react';

interface BreadcrumbProps {
  items: { label: string; link: string }[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className={className || 'container mx-auto px-6'}
    >
      <ol className="flex items-center justify-start overflow-x-auto  mx-auto">
        {items.map((item, idx) => (
          <li
            className="whitespace-nowrap text-sm"
            key={`item-${idx.toString()}`}
          >
            <span>
              {idx === items.length - 1 ? (
                <span className="font-medium">{item.label}</span>
              ) : (
                <Link className="opacity-50" to={item.link}>
                  {item.label}
                </Link>
              )}
            </span>
            {idx !== items.length - 1 && <span className="pl-2"> . </span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
